export const apiUrl = 'http://127.0.0.1:7008';
// export const dreditionApiUrl = 'http://127.0.0.1:9600';
export const dreditionApiUrl = 'https://dredition-api.aptoma.no';
